<fieldset [disabled]="isReadonly">
  <div [formGroup]="form" class="flex flex-wrap -mx-2 items-start">
    <div class="flex-none w-1/6 px-2" *ngIf="!isReadonly">
      <span class="pt-4">Filters: </span>
    </div>
    <div formArrayName="filters" [ngClass]="isReadonly ? 'flex-none w-full px-2' : 'flex-none w-5/6 px-2'">
      <ng-container *ngFor="let item of filters.controls; let index = index">
        <div class="flex flex-wrap -mx-2 flex-nowrap" [formGroupName]="index">
          <div class="flex-none w-5/12 px-2">
            <app-typeahead-dropdown
              label="Select Field"
              placeholder="Select Field"
              labelKey="displayName"
              valueKey="name"
              formControlName="field"
              [hideClearButton]="isReadonly"
              [showDefaultOption]="false"
              [options]="fields"
              (onChangeEvent)="onFieldsChanged(index, $event)"
            ></app-typeahead-dropdown>
          </div>
          <div [ngClass]="isReadonly ? 'flex-none w-1/4 px-2' : 'flex-none w-1/6 px-2'">
            <mat-form-field appearance="outline" class="mb-2 w-full">
              <mat-label>Operator</mat-label>
              <mat-select formControlName="operator" placeholder="Operator" panelWidth="205px" #siSelectRef="matSelect">
                <ng-container *ngIf="filters.controls[index]?.get('dataType')?.value">
                  <mat-option
                    *ngFor="let operator of operators[filters.controls[index]?.get('dataType')?.value]?.operators"
                    [value]="operator"
                  >{{operatorDisplayName[operator]}}</mat-option>
                </ng-container>
              </mat-select>
              <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
            </mat-form-field>
          </div>
          <div class="flex-none w-1/3 px-2">
            <ng-container *ngTemplateOutlet="valueTpl; context: {
              $implicit: fieldDataByFieldName[filters.controls[index]?.get('field')?.value],
              operator: filters.controls[index]?.get('operator')?.value
            }"></ng-container>

            <ng-template #valueTpl let-fieldData let-operator="operator">
              <ng-container [ngSwitch]="fieldData?.dataType">
                <ng-container *ngSwitchCase="fieldTypeEnum.DATETIME">
                  <ng-container *ngTemplateOutlet="calendarTpl"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="fieldTypeEnum.DATE">
                  <ng-container *ngTemplateOutlet="calendarTpl"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="fieldTypeEnum.ENUM">
                  <mat-form-field appearance="outline" class="mb-2 w-full">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="values" placeholder="Value" multiple #siSelectRef2="matSelect">
                      <mat-option
                        *ngFor="let enumValue of fieldData.enumValues"
                        [value]="enumValue.name"
                      >{{enumValue.displayName}}</mat-option>
                    </mat-select>
                    <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="fieldTypeEnum.NUMBER">
                  <ng-container *ngIf="operator !== operatorEnum.BETWEEN; else rangeTpl">
                    <mat-form-field appearance="outline" class="mb-2 w-full">
                      <mat-label>Value</mat-label>
                      <input matInput formControlName="value" type="text" placeholder="Value" numberWithComma>
                    </mat-form-field>
                  </ng-container>

                  <ng-template #rangeTpl>
                    <div class="flex flex-wrap -mx-2" formGroupName="range">
                      <div class="flex-none w-1/2 px-2">
                        <mat-form-field appearance="outline" class="mb-2 w-full">
                          <mat-label>From</mat-label>
                          <input matInput formControlName="lowValue" type="text" placeholder="From" numberWithComma>
                        </mat-form-field>
                      </div>
                      <div class="flex-none w-1/2 px-2">
                        <mat-form-field appearance="outline" class="mb-2 w-full">
                          <mat-label>To</mat-label>
                          <input matInput formControlName="highValue" type="text" placeholder="To" numberWithComma>
                        </mat-form-field>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <ng-container *ngIf="fieldData?.enumValues?.length; else defaultTpl">
                    <mat-form-field appearance="outline" class="mb-2 w-full">
                      <mat-label>Value</mat-label>
                      <mat-select formControlName="value" placeholder="Value" #siSelectRef3="matSelect">
                        <mat-option
                          *ngFor="let enumValue of fieldData.enumValues"
                          [value]="enumValue.name"
                        >{{enumValue.displayName}}</mat-option>
                      </mat-select>
                      <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef3.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                    </mat-form-field>
                  </ng-container>

                  <ng-template #defaultTpl>
                    <mat-form-field appearance="outline" class="mb-2 w-full">
                      <mat-label>Value</mat-label>
                      <input matInput formControlName="value" type="text" placeholder="Value">
                    </mat-form-field>
                  </ng-template>
                </ng-container>

                <ng-template #calendarTpl>
                  <ng-container *ngIf="operator !== operatorEnum.BETWEEN; else rangeTpl">
                    <mat-form-field class="mb-2 w-full" appearance="outline">
                      <mat-label>Choose a date</mat-label>
                      <input matInput formControlName="value" [matDatepicker]="picker">
                      <mat-hint>MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </ng-container>

                  <ng-template #rangeTpl>
                    <mat-form-field appearance="outline" class="mb-2 w-full">
                      <mat-label>Enter a date range</mat-label>
                      <mat-date-range-input formGroupName="range" [rangePicker]="picker">
                        <input matStartDate formControlName="lowValue" placeholder="Start date">
                        <input matEndDate formControlName="highValue" placeholder="End date">
                      </mat-date-range-input>
                      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                  </ng-template>
                </ng-template>

              </ng-container>
            </ng-template>
          </div>
          <div *ngIf="!isReadonly" class="flex-none w-1/12 px-2">
            <button matIconButton class="mt-2 mat-error" *ngIf="filters.length > 1"  (click)="onRemoveFilter(index)">
              <fa-icon class="si-icon" [icon]="['fal', 'trash-can']"></fa-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="flex flex-wrap -mx-2" *ngIf="!isReadonly">
    <div class="flex-none w-5/6 ml-[16.666667%] px-2">
      <div class="flex flex-wrap -mx-2 justify-end">
        <div class="flex-none w-auto px-2">
          <ng-content></ng-content>
        </div>
        <div class="flex-none w-auto px-2">
          <button matButton="outlined" [disabled]="filters.length >= 3" (click)="onAddFilter()">Add Filter</button>
        </div>
        <div class="flex-none w-1/12 px-2"></div>
      </div>
    </div>
  </div>
</fieldset>
